export enum ConnectionCores {
    SINGLE = 'single',
    MULTI = 'multi',
    MULTI_PE = 'multi-pe',
}

export const ConnectionCoresOptions = [
    {
        value: ConnectionCores.SINGLE,
        label: 'Single',
    },
    {
        value: ConnectionCores.MULTI,
        label: 'Multi',
    },
    {
        value: ConnectionCores.MULTI_PE,
        label: 'Multi + PE',
    },
];
